import { Crown, X } from 'lucide-react';
import ModalBackdrop from '@/components/ModalBackdrop';
import type { NativePlatform } from '@/utils/native-platform';

interface NativePremiumNoticeModalProps {
  open: boolean;
  onClose: () => void;
  platform: NativePlatform;
  feature?: string;
}

export default function NativePremiumNoticeModal({
  open,
  onClose,
  platform,
  feature,
}: NativePremiumNoticeModalProps) {
  if (!open) {
    return null;
  }
  const title = platform === 'android'
    ? 'Premium köps via Google Play'
    : platform === 'ios'
      ? 'Premium köps via Apple App Store'
      : 'Premium köps i appbutiken';

  return (
    <ModalBackdrop onClick={onClose} viewportCentered={true} className="z-[9999] p-4">
      <div
        onClick={(event) => event.stopPropagation()}
        className="relative w-full max-w-md rounded-xl border border-border bg-card shadow-xl"
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg p-1 transition-colors hover:bg-muted"
          aria-label="Stäng"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="p-6">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-amber-500/15 p-4">
              <Crown className="h-8 w-8 text-amber-500 dark:text-amber-400" />
            </div>
          </div>

          <h2 className="mb-3 text-center text-xl font-bold">{title}</h2>

          {feature && (
            <p className="mb-3 text-center text-sm text-muted-foreground">
              {feature} kräver Premium.
            </p>
          )}

          <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 text-sm text-muted-foreground">
            <p className="mt-2">
              Öppna inställningarna i appen och välj Skaffa Premium för att starta köpet.
            </p>
          </div>

          <button
            onClick={onClose}
            className="mt-6 w-full rounded-lg btn-primary-custom px-4 py-2"
          >
            Okej
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}